import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { ROLES } from '@/api/routes/users/types';
import useRoleAccess from '@/hooks/useRoleAccess';

import AccessDenied from '../ErrorPage/examples/AccessDenied';

export interface RoleGuardProps {
  roles: ROLES [],
  strict?: boolean,
  additionalRequiredRoles?: ROLES[],
}

const RoleGuard: FC<PropsWithChildren<RoleGuardProps>> = ({
  roles,
  children,
  additionalRequiredRoles,
  strict = false,
}) => {
  const isAccess = useRoleAccess(roles, strict, additionalRequiredRoles);

  if (isAccess) {
    return children as React.ReactElement;
  }

  return <AccessDenied />;
};

export default RoleGuard;
